<script lang="ts" setup>
import { ButtonComponent } from '@metapic-apps/shared'
import { onBeforeUnmount, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import RefreshIcon from '@/assets/icons/refresh.svg?component'
import CloseIcon from '@/assets/icons/remove.svg?component'
import { useCampaignParticipantsStore } from '@/stores/campaign-participants.stores'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

const emit = defineEmits({
  refresh: () => true,
})
const route = useRoute()
const isShown = ref(false)
const isForcedClosed = ref(false)
const campaignParticipantsStore = useCampaignParticipantsStore()
const handleUpdate = () => {
  campaignParticipantsStore.setHasUpdates(false)
  emit('refresh')
}
const handleClose = () => {
  isShown.value = false
  isForcedClosed.value = true
}

watch(
  () => route.query.participant,
  () => {
    if (route.query.participant && campaignParticipantsStore.hasUpdates) {
      handleUpdate()
    }
  },
  { immediate: true },
)
watch(
  () => campaignParticipantsStore.hasUpdates,
  (newValue) => {
    if (!isForcedClosed.value) {
      isShown.value = newValue
    }
  },
  { immediate: true },
)
onBeforeUnmount(() => campaignParticipantsStore.setHasUpdates(false))
</script>
<template>
  <BoxComponent v-if="isShown" class="campaign-participant-refresh-modal__wrapper">
    <el-icon :size="24">
      <RefreshIcon />
    </el-icon>
    <FlexComponent direction="column" :gap="16">
      <TypographyComponent variant="title-large">Campaign updated</TypographyComponent>
      <TypographyComponent variant="body-medium">
        Someone else just made changes to this campaign. Refresh to see the latest version.
      </TypographyComponent>
      <ButtonComponent variant="primary" @click="handleUpdate()"> Refresh now </ButtonComponent>
    </FlexComponent>
    <el-icon :size="24" color="var(--primary)" @click="handleClose()">
      <CloseIcon />
    </el-icon>
  </BoxComponent>
</template>
<style scoped lang="scss">
:deep(.el-icon) {
  path {
    fill: currentColor;
  }
}
.campaign-participant-refresh-modal__wrapper {
  position: fixed;
  z-index: 10;
  bottom: 48px;
  margin: 0 auto;
  left: 0;
  right: 0;
  background: var(--inverted);

  display: flex;
  width: min(440px, 100%);
  padding: 16px 12px 16px 16px;
  align-items: flex-start;
  gap: 12px;
}
</style>
